"use client";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./apollo-client";
import { ApolloCacheGc } from "./apollo-cache-gc";

export default function GraphQLProviders({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProvider client={apolloClient}>
      <ApolloCacheGc />
      {children}
    </ApolloProvider>
  );
}
